/**
 * authFetch — wrapper around fetch() that automatically attaches the
 * current Supabase session JWT as a Bearer token on the Authorization header.
 *
 * The backend's requireAuth middleware verifies this token. Without it,
 * every API call returns 401.
 *
 * Usage:
 *   import { authFetch } from '../../utils/authFetch';
 *   const res = await authFetch(`${API_BASE_URL}/api/whatsapp/templates`);
 *
 * For multipart/form-data uploads, do NOT set Content-Type yourself —
 * pass FormData as the body and let the browser set the boundary.
 */

import { supabase } from './supabaseClient';

export async function authFetch(url, options = {}) {
  let { data } = await supabase.auth.getSession();
  let token = data?.session?.access_token;
  const expiresAt = data?.session?.expires_at; // epoch seconds

  // If token expires within 60 seconds, proactively refresh
  if (expiresAt && Date.now() / 1000 > expiresAt - 60) {
    console.log('🔄 authFetch: Token expiring soon, refreshing...');
    const { data: refreshed } = await supabase.auth.refreshSession();
    if (refreshed?.session?.access_token) {
      token = refreshed.session.access_token;
    }
  }

  const headers = new Headers(options.headers || {});
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(url, { ...options, headers });
}

export default authFetch;
